import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  ResendEstimateInput,
  ResendEstimateMutation as ResendEstimateMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const ResendEstimateMutation = graphql(`
  mutation ResendEstimate($input: ResendEstimateInput!) {
    resendEstimate(input: $input) {
      id
    }
  }
`);

const useResendEstimate = (args: {
  projectId: string;
  options?: UseMutationOptions<
    ResendEstimateMutationResult,
    Error,
    ResendEstimateInput
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (input: ResendEstimateInput) => {
      return gqlClient.request(ResendEstimateMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useResendEstimate;
